// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__RKwMd","co-applicants":"search_co-applicants__ZJFiC","application-id":"search_application-id__lIoQw"};